import { render } from "./ImportAddress.vue?vue&type=template&id=7a636f95&scoped=true"
import script from "./ImportAddress.vue?vue&type=script&lang=js"
export * from "./ImportAddress.vue?vue&type=script&lang=js"

import "./ImportAddress.vue?vue&type=style&index=0&id=7a636f95&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a636f95"]])

export default __exports__